import { IElementBaseModel } from '../../../Interface/base/element-base-model.interface';
import { IFrame } from '../frame.interface';
import { IMultiFrameProps, IMultiplyFrameProperty, IMultiValueProps } from './index.interface';
import BaseFrame from '../base';
import { IValueProps, IFrameProps } from '../base/base.interface';

const DEFAULT_OFFSET_FRAME = { left: 0, top: 0, width: 0, height: 0,
    flipV: undefined, flipH: undefined, rotate: 0 };

export default class MultiplyFrame extends BaseFrame implements IMultiplyFrameProperty {
    private updateModelArr: IElementBaseModel[] = []; // 待更新的元素数组
    public constructor(modelArr: IElementBaseModel[]) {
        super(modelArr[0]);
        // 传入第一个元素主要是用来判断多选是否发生在组合中
        this.updateModelArr = [...modelArr];
    }

    public updateHeight(props: IValueProps): void {
        this.batchUpdateFrameHandler.batchUpdateHeight({
            ...props, value: this.getValueArr(props.value),
            updateModelArr: this.updateModelArr,
        });
    }

    public updateWidth(props: IValueProps): void {
        this.batchUpdateFrameHandler.batchUpdateWidth({
            ...props, value: this.getValueArr(props.value),
            updateModelArr: this.updateModelArr,
        });
    }

    public updateLeft(value: number, isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateLeft(this.getValueArr(value), this.updateModelArr, isOnSlide);
    }

    public updateTop(value: number, isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateTop(this.getValueArr(value), this.updateModelArr, isOnSlide);
    }

    public updateRotate(value: number, isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateRotateToAngle(value, this.updateModelArr, isOnSlide);
    }

    public rotateByCurrent(value: number, isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateRotateWithAngle(value, this.updateModelArr, isOnSlide);
    }

    public updateFrame(props: IFrameProps): void {
        this.batchUpdateFrameHandler.batchUpdateFrame({
            ...props, frame: this.getValueArr(props.frame),
            updateModelArr: this.updateModelArr,
        });
    }

    public updateFrameOnSlide(props: IFrameProps) {
        this.batchUpdateFrameHandler.batchUpdateFrameOnSlide({
            ...props, frame: this.getValueArr(props.frame),
            updateModelArr: this.updateModelArr,
        });
    }

    public updateDiffHeight(props: IMultiValueProps): void {
        this.batchUpdateFrameHandler.batchUpdateHeight({ ...props, updateModelArr: this.updateModelArr });
    }

    public updateDiffWidth(props: IMultiValueProps): void {
        this.batchUpdateFrameHandler.batchUpdateHeight({ ...props, updateModelArr: this.updateModelArr });
    }

    public updateDiffLeft(value: number[], isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateLeft(value, this.updateModelArr, isOnSlide);
    }

    public updateDiffTop(value: number[], isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateTop(value, this.updateModelArr, isOnSlide);
    }

    public updateDiffRotate(value: number[], isOnSlide?: boolean): void {
        this.batchUpdateFrameHandler.batchUpdateRotateToAngle(value, this.updateModelArr, isOnSlide);
    }

    public updateDiffFrame(props: IMultiFrameProps): void {
        this.batchUpdateFrameHandler.batchUpdateFrame({ ...props, updateModelArr: this.updateModelArr });
    }

    public updateDiffFrameOnSlide(props: IMultiFrameProps): void {
        this.batchUpdateFrameHandler.batchUpdateFrameOnSlide({ ...props, updateModelArr: this.updateModelArr });
    }

    protected getFinalFrameInfo(isOperating?: boolean, isOnSlide?: boolean, currentFrame?: IFrame): IFrame {
        const rect = { ...DEFAULT_OFFSET_FRAME };
        Object.keys(rect).forEach((item) => {
            rect[item] = this.getStyleValue(item, isOnSlide, currentFrame, isOperating);
        });
        return rect;
    }

    /**
     * 获取style中的具体某个字段
     */
    private getStyleValue = (
        item: string, isOnSlide?: boolean,
        currentFrame?: IFrame, isOperating?: boolean,
    ): number => {
        const { length } = this.updateModelArr;
        const size = (isOnSlide ? this.updateModelArr[0].getFrame().frameOnSlide(currentFrame, isOperating)
            : this.getFinalFrame(this.updateModelArr[0], isOperating))[item];
        for (let index = 1; index < length; index++) {
            const nextSize = (isOnSlide ? this.updateModelArr[index].getFrame().frameOnSlide(currentFrame, isOperating)
                : this.getFinalFrame(this.updateModelArr[index], isOperating))[item];
            if (Math.round(size) !== Math.round(nextSize)) {
                return Number.NaN;
            }
        }
        return size;
    };

    private getValueArr = <T>(value: T): T[] => this.updateModelArr.map(() => value);
}
